<script>
import SpinLoader from '@/components/SpinLoader'

export default {
    name: "Subscribe",
    components: {SpinLoader},
    data() {
        return {
            selectedGame: "gta5",
            selectedPeriodSlug: "3m",
            firstBlockCompleted: false,
            checkboxReady: false,
            isDropdownVisible: false,
            isDropdownTierVisible: false,
            loading: true,
            games: [

            ]
        }
    },
    computed: {
        selectedGameData() {
            return this.games.find(game => game.slug === this.selectedGame)
        },
        price() {
            return this.selectedGameData.items.find(item => item.slug === this.selectedPeriodSlug).price
        }
    },
    methods: {
        getGameTitleBySlug(slug) {
            const game = this.games.find(game => game.slug === slug)
            return game ? game.title : null
        },
        getTierBySlug(slug) {
            const game = this.games.find(game => game.slug === slug)
            return game ? game.tier : 0
        },
        getTierTitleBySlug(slug) {
            const game = this.games.find(game => game.slug === slug)
            return game ? game.tierTitle : null
        },
        getGameIconBySlug(slug) {
            const game = this.games.find(game => game.slug === slug)
            return game ? game.icon : null
        },
        toggleDropdown() {
            this.isDropdownVisible = !this.isDropdownVisible
        },
        toggleTierDropdown() {
            this.isDropdownTierVisible = !this.isDropdownTierVisible
        },
        updateUrl() {
            const selectedTier = this.getTierBySlug(this.selectedGame)

            this.$router.replace({
                name: 'subscribe',
                query: {
                    game: this.selectedGame,
                    period: this.selectedPeriodSlug,
                    tier: selectedTier,
                },
            })
        },
        selectGame(slug) {
            const game = this.games.find(game => game.slug === slug);
            if (game) {
                this.selectedGame = slug
            }
        },
        goToPay() {
            this.$router.push({ path: '/pay', query: this.$route.query })
        }
    },
    watch: {
        selectedGame: "updateUrl",
        selectedPeriodSlug: "updateUrl",
    },
    async created() {
        this.loading = true

        try {
            const response = await fetchServer('/subscriptions')
            if(response['err']) {
                alert('Ошибка! Попробуйте позже')
                return
            }

            if(response['internalError']) {
                alert('Ошибка! Попробуйте позже')
                return
            }

            for(let subscription of response) {
                const gamePeriods = [
                    { period: `${this.__('1 месяц')}`, price: !subscription.discount ? subscription.prices[0] : subscription.discountPrices[0], slug: "1m", discount: subscription.discount || 0 },
                    { period: `${this.__('3 месяца')}`, price: !subscription.discount ? subscription.prices[1] : subscription.discountPrices[1], slug: "3m", discount: subscription.discount || 12 },
                    { period: `${this.__('6 месяцев')}`, price: !subscription.discount ? subscription.prices[2] : subscription.discountPrices[2], slug: "6m", discount: subscription.discount || 22 },
                    { period: `${this.__('1 год')}`, price: !subscription.discount ? subscription.prices[3] : subscription.discountPrices[3], slug: "12m", discount: subscription.discount || 32 },
                ]

                this.games.push({
                    tier: subscription.tier,
                    tierTitle: subscription.tier === 1 ? 'Game Plus': 'Cloud Premium',
                    title: subscription.title || this.__('Все игры'),
                    slug: subscription.game,
                    icon: subscription.title ? require(`@/assets/images/gameIcons/${subscription.game}.png`) : require('@/assets/images/gameIcons/all.svg'),
                    items: gamePeriods
                })
            }

            this.loading = false

        } catch (e) {

        } finally {
            this.loading = false
        }

        if(!this.$route.query.game) {
            this.$route.query.game = 'gta5'
        }
        this.selectedGame = this.$route.query.game

        if(!this.$route.query.period) {
            this.$route.query.period = '3m'
        }
        this.selectedPeriodSlug = this.$route.query.period

        const selectedItem = this.selectedGameData.items.find(item => item.slug === this.$route.query.period)
        if (selectedItem) this.selectedPeriod = selectedItem.period

        if(!this.$route.query.tier) {
            this.$route.query.tier = 1
        }
    }
}
</script>

<template>
<section class="subscribe">
    <SpinLoader :size="48" v-if="loading" />
    <div class="subscribe-box" v-else>
        <div class="sub-text-container">
            {{__('Оформление подписки')}}
            <div class="divider"></div>
        </div>
        <div class="sub-select-container">
            {{__('Уровень подписки:')}}
            <div class="sub-box" @click= "toggleTierDropdown">
                <div class="sub-type">
                    <svg width="18" v-if="getTierBySlug(selectedGame) === 1" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99983 3.59998C9.21798 3.59998 9.42187 3.70785 9.54341 3.88763L12.0176 7.54729L15.0558 4.15327C15.2516 3.93454 15.5707 3.87271 15.8351 4.00225C16.0995 4.13179 16.2439 4.42075 16.1878 4.70793L14.4296 13.7102C14.3804 13.9622 14.2835 14.195 14.1493 14.4C13.2037 12.7945 11.1698 11.684 8.81322 11.684C6.61516 11.684 4.69782 12.6501 3.68249 14.0828C3.63332 13.9645 3.59536 13.8399 3.57003 13.7102L1.8118 4.70793C1.75571 4.42075 1.90014 4.13179 2.16453 4.00225C2.42893 3.87271 2.74801 3.93454 2.94382 4.15327L5.98201 7.54729L8.45623 3.88763C8.57778 3.70785 8.78161 3.59998 8.99983 3.59998Z" fill="#4F4F4F"/>
                </svg>
                    <svg width="18" v-if="getTierBySlug(selectedGame) === 2" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99983 3.59998C9.21798 3.59998 9.42187 3.70785 9.54341 3.88763L12.0176 7.54729L15.0558 4.15327C15.2516 3.93454 15.5707 3.87271 15.8351 4.00225C16.0995 4.13179 16.2439 4.42075 16.1878 4.70793L14.4296 13.7102C14.3804 13.9622 14.2835 14.195 14.1493 14.4C13.2037 12.7945 11.1698 11.684 8.81322 11.684C6.61516 11.684 4.69782 12.6501 3.68249 14.0828C3.63332 13.9645 3.59536 13.8399 3.57003 13.7102L1.8118 4.70793C1.75571 4.42075 1.90014 4.13179 2.16453 4.00225C2.42893 3.87271 2.74801 3.93454 2.94382 4.15327L5.98201 7.54729L8.45623 3.88763C8.57778 3.70785 8.78161 3.59998 8.99983 3.59998Z" fill="#FFD089"/>
                    </svg>
                    {{ getTierTitleBySlug(selectedGame) }}
                </div>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.95378 10.9117L13.3704 7.49504C13.5232 7.34226 13.7003 7.26587 13.9017 7.26587C14.1031 7.26587 14.2802 7.34226 14.4329 7.49504C14.5857 7.64781 14.6621 7.8249 14.6621 8.02629C14.6621 8.22767 14.5834 8.40712 14.4259 8.56462L10.4746 12.5159C10.3996 12.5853 10.3184 12.6374 10.2309 12.6721C10.1434 12.7068 10.0496 12.7242 9.94961 12.7242C9.84961 12.7242 9.75586 12.7068 9.66836 12.6721C9.58086 12.6374 9.50239 12.5853 9.43294 12.5159L5.48169 8.56462C5.32419 8.40712 5.24891 8.23115 5.25586 8.0367C5.2628 7.84226 5.34266 7.66865 5.49544 7.51587C5.64822 7.36309 5.8253 7.2867 6.02669 7.2867C6.22808 7.2867 6.40516 7.36309 6.55794 7.51587L9.95378 10.9117Z" fill="#4F4F4F"/>
                </svg>
                <div class="sub-context-menu" v-show="isDropdownTierVisible">
                    <div class="context-game-button" @click="selectGame('gta5')">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99983 3.59998C9.21798 3.59998 9.42187 3.70785 9.54341 3.88763L12.0176 7.54729L15.0558 4.15327C15.2516 3.93454 15.5707 3.87271 15.8351 4.00225C16.0995 4.13179 16.2439 4.42075 16.1878 4.70793L14.4296 13.7102C14.3804 13.9622 14.2835 14.195 14.1493 14.4C13.2037 12.7945 11.1698 11.684 8.81322 11.684C6.61516 11.684 4.69782 12.6501 3.68249 14.0828C3.63332 13.9645 3.59536 13.8399 3.57003 13.7102L1.8118 4.70793C1.75571 4.42075 1.90014 4.13179 2.16453 4.00225C2.42893 3.87271 2.74801 3.93454 2.94382 4.15327L5.98201 7.54729L8.45623 3.88763C8.57778 3.70785 8.78161 3.59998 8.99983 3.59998Z" fill="#4F4F4F"/>
                    </svg>
                        Game Plus
                    </div>
                    <div class="context-game-button" @click="selectGame('all')">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99983 3.59998C9.21798 3.59998 9.42187 3.70785 9.54341 3.88763L12.0176 7.54729L15.0558 4.15327C15.2516 3.93454 15.5707 3.87271 15.8351 4.00225C16.0995 4.13179 16.2439 4.42075 16.1878 4.70793L14.4296 13.7102C14.3804 13.9622 14.2835 14.195 14.1493 14.4C13.2037 12.7945 11.1698 11.684 8.81322 11.684C6.61516 11.684 4.69782 12.6501 3.68249 14.0828C3.63332 13.9645 3.59536 13.8399 3.57003 13.7102L1.8118 4.70793C1.75571 4.42075 1.90014 4.13179 2.16453 4.00225C2.42893 3.87271 2.74801 3.93454 2.94382 4.15327L5.98201 7.54729L8.45623 3.88763C8.57778 3.70785 8.78161 3.59998 8.99983 3.59998Z" fill="#FFD089"/>
                        </svg>
                        Cloud Premium
                    </div>
                </div>
            </div>
        </div>
        <div class="sub-select-container">
            {{ __('Выберите игру:') }}
            <div class="sub-box" @click= "toggleDropdown">
                <div class="sub-type">
                    <img :src="getGameIconBySlug(selectedGame)" alt="Game Icon" class="gameiconimage" width="18" height="18"/>
                    {{ getGameTitleBySlug(selectedGame) }}
                </div>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.95378 10.9117L13.3704 7.49504C13.5232 7.34226 13.7003 7.26587 13.9017 7.26587C14.1031 7.26587 14.2802 7.34226 14.4329 7.49504C14.5857 7.64781 14.6621 7.8249 14.6621 8.02629C14.6621 8.22767 14.5834 8.40712 14.4259 8.56462L10.4746 12.5159C10.3996 12.5853 10.3184 12.6374 10.2309 12.6721C10.1434 12.7068 10.0496 12.7242 9.94961 12.7242C9.84961 12.7242 9.75586 12.7068 9.66836 12.6721C9.58086 12.6374 9.50239 12.5853 9.43294 12.5159L5.48169 8.56462C5.32419 8.40712 5.24891 8.23115 5.25586 8.0367C5.2628 7.84226 5.34266 7.66865 5.49544 7.51587C5.64822 7.36309 5.8253 7.2867 6.02669 7.2867C6.22808 7.2867 6.40516 7.36309 6.55794 7.51587L9.95378 10.9117Z" fill="#4F4F4F"/>
                </svg>
                <div class="sub-context-menu" v-if="getTierBySlug(selectedGame) === 1" v-show="isDropdownVisible">
                    <div class="context-game-button" @click="selectGame('gta5')"><img src="@/assets/images/gameIcons/gta5.png" class="context-icon">{{ getGameTitleBySlug('gta5') }}</div>
                    <div class="context-game-button" @click="selectGame('minecraft')"><img src="@/assets/images/gameIcons/minecraft.png" class="context-icon">{{ getGameTitleBySlug('minecraft') }}</div>
                </div>
                <div class="sub-context-menu" v-if="getTierBySlug(selectedGame) === 2" v-show="isDropdownVisible">
                    <div class="context-game-button" @click="selectGame('all')"><img src="@/assets/images/gameIcons/all.svg" class="context-icon">{{ __('Все игры') }}</div>
                </div>
            </div>
        </div>
        <div class="sub-select-container">
            {{ __('Выберите периодичность:') }}
            <div
                class="sub-time-box"
                v-for="(data, index) in selectedGameData.items"
                :key="index"
                @click="selectedPeriodSlug = data.slug"
                :class="{ 'selected': selectedPeriodSlug === data.slug }"
            >
                <div class="sub-time-container">
                    <label :for="'period-' + data.period">{{ data.period }}</label>
                </div>
                <div class="sub-price-container">
                    {{ data.price }} ₽
                    <div class="sub-price-sale" v-if="data.discount > 0">
                        -{{ data.discount }}%
                    </div>
                </div>
            </div>
        </div>
        <div class="sub-button" @click="goToPay">{{ __('Продолжить') }}</div>
    </div>
</section>
</template>

<style scoped>
.subscribe {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    background-repeat: no-repeat;
    background-position: center;
    user-select: none;
}

.subscribe-box {
    display: flex;
    background: var(--bg-secondary);
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.divider {
    background: #323030;
}

.sub-text-container {
    display: flex;
    flex-direction: column;
    color: var(--text-primary);
    font-weight: 700;
}

.sub-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    transition: 0.2s ease;

    background: var(--bg-accent);
}

.sub-box:hover {
    cursor: pointer;
    background: var(--button-main);
}

.sub-type {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-primary);
    font-weight: 600;
}

.sub-select-container {
    display: flex;
    flex-direction: column;
    font-weight: 600;
    color: var(--text-accent);
}

.sub-time-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--bg-accent);
    box-sizing: border-box;
}

.sub-price-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.sub-price-sale {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-main);
}

.sub-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-main);
    transition: 0.25s ease;
}

.radio-css {
    background: #0077FF;
}

.sub-time-box {
    transition: 0.25s ease;
}

.sub-time-box:hover {
    background: var(--button-main);
    cursor: pointer;
}

.sub-time-box.selected {
    background: var(--button-main);
}

.sub-button:hover {
    background: #6143CE;
    cursor: pointer;
}

.payment-method {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: var(--bg-accent);

    transition: 0.25s ease;
}

.payment-method:hover {
    background: var(--color-main);
    cursor: pointer;
}

.payment-container {
    display: flex;
    flex-direction: row;
}

.mail-input {
    font-family: 'TT Interfaces';
    font-weight: 600;

    border: 1px solid rgba(255, 255, 255, 0.05);
    background: var(--bg-accent, #0D0D0D);
}

input, input:focus, input:active, textarea, textarea:focus, textarea:active {
    background: transparent;
    outline: none;
    border: 0;
    padding: 0;
    margin: 0;
    user-select: auto;
    font-family: 'TT Interfaces', sans-serif;
    resize: none;
}

.checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #151515;
    box-shadow: 0px 2px 2px 0px rgba(27, 28, 29, 0.12);

    transition: 0.2s ease;
}

.checkbox:hover {
    cursor: pointer;
}

.checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.checkbox-text {
    color: var(--text-primary);
    font-weight: 600;
}

.sub-context-menu {
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: rgba(6, 6, 6, 0.80);
    backdrop-filter: blur(27px);
}

.context-game-button {
    display: flex;
    align-items: center;
    color: var(--text-secondary);

    transition: 0.15s ease;
}

.context-game-button:hover {
    background: rgba(29, 29, 29, 0.60);
    backdrop-filter: blur(27px);
    cursor: pointer;
    color: var(--text-primary);
}

@media (min-width: 320px) {

}

@media (min-width: 464px) {

}

@media (min-width: 744px) {

}

@media (min-width: 984px) {

}

@media (min-width: 1248px) {
    .subscribe {
        background-image: url("@/assets/images/subscribe1244.png");
        height: 940px;
    }

    .subscribe-box {
        width: 467px;
        padding: 44px 28px;
        border-radius: 15px;
        gap: 30px;
    }

    .divider {
        width: 410px;
        height: 1px;
    }

    .sub-text-container {
        gap: 24px;
        font-size: 18px;
    }

    .sub-box {
        position: relative;
        padding: 22px;
        border-radius: 12px;
        width: 410px;
        height: 46px;
    }

    .sub-type {
        gap: 6px;
        font-size: 16px;
    }

    .sub-select-container {
        gap: 12px;
        font-size: 16px;
    }

    .sub-time-box {
        border-radius: 12px;
        width: 410px;
        height: 46px;
        padding: 22px;
    }

    .sub-price-container {
        gap: 12px;
    }

    .sub-price-sale {
        filter: drop-shadow(0px 4px 24px rgba(120, 83, 255, 0.50));
        border-radius: 6px;
        padding: 3px 4px;
        font-size: 13px;
    }

    .sub-button {
        width: 410px;
        height: 44px;
        border-radius: 9px;
    }

    .gameiconimage {
        height: 20px;
        width: 20px;
    }

    .payment-method {
        width: 195px;
        height: 107px;
        border-radius: 15px;

        gap: 8px;
    }

    .payment-method-title {
        text-align: center;
        font-size: 14px;
        width: 145px;
    }

    .payment-container {
        gap: 12px;
    }

    .mail-input {
        width: 410px;
        height: 46px;
        border-radius: 12px;
        padding: 22px;

        color: var(--text-primary);
    }

    input, input:focus, input:active, textarea, textarea:focus, textarea:active {
        padding: 22px;
        border: 1px solid rgba(255, 255, 255, 0.05);
        background: var(--bg-accent, #0D0D0D);
    }

    .next-payment {
        width: 409px;
        font-size: 15px;
        font-weight: 500;
        opacity: 0.6;
    }

    .checkbox {
        width: 16px;
        height: 16px;

        border-radius: 2.6px;
    }

    .checkbox-container {
        gap: 12px;
    }

    .checkbox-text {
        width: 379px;
        font-size: 16px;
    }

    .sub-context-menu {
        border-radius: 12px;
        padding: 8px 8px;
    }

    .context-game-button {
        width: 396px;
        height: 39px;
        border-radius: 12px;
        padding: 12px;
        gap: 12px;
    }

    .context-icon {
        height: 20px;
        width: 20px;
    }
}
</style>